import React, { useEffect, useRef, useState, FC } from "react";
import { Button, message, Input, Tooltip, Form, Upload, Modal } from "antd";
import { YhFormBox } from "@/components/YhFormBoxVertical";
import { IYhFormBox, IYhFormItemsBox, FormItemTypeEnum, ISelectOption } from "@/components/YhFormBoxVertical/Types";
import useNavModel, { } from "@/model/navModel";
import { formatNum, repairFormatNum } from "@/utils/utils"
import { globalPrompt } from "@/components/message";
import { useSaleOrderDetailModel } from "./saleOrderDetailModel";
import { DictCodeEnmu } from "@/types/VrmSaDictEnums";
import { useDictModel } from "@/views/base/dict/dictModel";
import useGlobalModel, { getFindItem, transOptions, vehicleOption, getVehicleItem, vinOption, getVinItem } from "@/model/globalModel";
import { vehicleService } from "@/views/base/customerFiles/vehicle/vehicleService";
import { IVehicleFields } from "@/views/base/customerFiles/vehicle/vehicleType";
import { ITopType } from "@/types/ScmTypes";
import { DetailType, ISalesTypeEnum, IPriceTypeEnum } from "@/types/ScmEnums";
import { debounce } from "lodash";
import { useSaleOrderModel } from "../../saleOrderModel";
import FontIcon from "@/components/YhIcon";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/VrmResoureAuthEnum";
import { purchaseDetailsService } from "@/views/stock/purchaseDetails/purchaseDetailsService";
import { stockStatisticService } from "@/views/stock/statistic/stockStatisticService";
import { getBaseImgLookUrl, getBaseImgUploadUrl, getBaseUploadData } from "@/utils/constants";
import { UploadOutlined } from "@ant-design/icons";
import { UploadChangeParam } from "antd/lib/upload";
import { UploadFile } from "antd/lib/upload/interface";
import { fileDownload } from "@/utils/exportFile";
import { Image } from 'antd';
import { YHDetailNav } from "@/components/YHDetailNav";
import { IVRMSettleTypeEnum } from "@/types/FmsDs";

export const FormBox: FC<ITopType> = ({ id, mode, IFormRef }) => {
    const {
        setSelectedRowKeys,
        setDescRows,
        setSelectedRow
    } = useSaleOrderModel();
    const { getSelectedDictOne } = useDictModel();
    const { getSettlementParty, beShopDs, CustomerData, shopAndOrg: { shopId, shopCode, shopName, shopType }, allShopDs } = useGlobalModel();

    const {
        detailEditForm,
        detailAddForm,
        detailLookForm,
        vehicleEditAll,
        vehicleAddAll,
        initForm,
        detailAddList,
        detailDataSource,
        addSaleType,
        updateAddFormVal,
        updatEditFormVal,
        getDetailEditOne,
        resetAddCatch,
        resetEditCatch,
        insertDetail,
        editDetail,
        setDetailAddForm,
        setDetailAddList,
        setTopButsControl,
        setVehicleAddAll,
        setVehicleEditAll,
        setDetailDataSource,
        setConsumeHistoryModel,
        setConsumeHistoryVisible,
        setRepairHistoryModel,
        setAddSaleType,
        formComputeRule,
        verifyGoods,
        saveLoading, setSaveLoading,
        editDesc, onTransfer, topButsControl
    } = useSaleOrderDetailModel();

    const [more, setMore] = useState<boolean>(true);  //控制更多按钮
    const { selectedNavId, replaceNav, getSelectedNavState, findNav } = useNavModel();
    let { priceTypeCode, salesTypeCode, customerCode } = mode === "add" ? detailAddForm : detailEditForm;
    const { getTreeNodeName, getTreeNodeOne } = useDictModel();

    useEffect(() => {
        if (!Object.keys(detailEditForm).length && mode === DetailType.edit) {
            resetEditCatch(mode);
            getDetailEditOne(id, mode)
        }
        mode === DetailType.look && getDetailEditOne(id, mode)
    }, [id, mode])
    useEffect(() => {
        return () => {
            !findNav("5-1-1") && resetAddCatch(mode);
            !findNav("5-1-2") && resetEditCatch(mode);
        }
    }, [selectedNavId, shopCode])

    const save = () => {
        if (!verifyGoods(mode)) return;
        if (!formComputeRule(mode)) return;

        IFormRef.current?.validateFields().then(async res => {
            if (res.settlementPartyCode === "settle-party.internal" && !!!res.note) {
                message.warning("销售类型为赠送服务时，备注为必填项，请补齐表单里的备注项");
                return false;
            }
            if (res.salesTypeCode === ISalesTypeEnum.GIVE && !!!res.note) {
                message.warning("销售类型为赠送服务时，备注为必填项，请补齐表单里的备注项");
                return false;
            }
            const { fileList = [], ...val } = res
            if (fileList.length > 0) {
                const file = fileList[0]
                if (!file?.uid) {
                    console.log(file)
                    return message.error('文件信息有误，请重新上传文件')
                }
                val.md5 = file?.uid
                val.fileName = file?.name
            }
            // else {
            //     val.md5 = ''
            //     val.fileName = ''
            // }
            if (mode === "add") {
                const resData = await insertDetail(val)
                if (resData) {
                    globalPrompt("message", { text: "新增成功", type: "success" });
                    resetAddCatch(mode);
                    setSelectedRowKeys([resData.id as string])
                    setDescRows([resData])
                    setSelectedRow(resData)
                    goBack();
                }
            } else if (mode === "edit") {
                let { id, saleOrderCode } = detailEditForm
                const resData = await editDetail({ ...val, id, saleOrderCode })
                if (resData) {
                    globalPrompt("message", { text: "编辑成功", type: "success" });
                    getDetailEditOne(saleOrderCode as string, mode)
                }
            }
        })
    }
    const goBack = () => {
        replaceNav(selectedNavId, "5-1")
    }
    const onRefresh = async () => {
        if (mode === 'add') {
            IFormRef.current?.resetFields()
            getVehicleAllList()
            setDetailAddForm(initForm)
            setDetailAddList([])
            setAddSaleType(ISalesTypeEnum.WEICHAI)

        } else if (mode === 'edit') {
            getDetailEditOne(id, mode)
        }
        message.success("刷新成功")
    }
    const onDiscount = () => {
        let discountVal: string = "";
        globalPrompt("modal", {
            width: 380,
            title: "折扣",
            type: "info",
            // text: "",
            text: <>
                <span>请输入折扣系数</span>
                <Input
                    onChange={(e) => { discountVal = e.target.value }}
                    suffix="%"
                />
            </>,
            okText: "确定",
            onOk: () => {
                var re = /^[0-9]+.?[0-9]*$/;
                return new Promise((resolve, reject) => {
                    if (!re.test(discountVal)) {
                        reject("输入的值不是数字，请重新输入")
                        message.error("输入的值不是数字，请重新输入")

                    } else {
                        resolve(discountVal)
                    }
                }).then(res => {
                    onSetDetailsTableDiscount(+discountVal)
                })
            },
            cancelText: "取消",
            onCancel: () => {
            }
        })
    }
    const onSetDetailsTableDiscount = async (discount: number) => {
        // debugger;SS
        let detailsList = mode === "add" ? detailAddList : detailDataSource
        // await detailsList.forEach((item) => {
        //     item.discountRate = discount;
        //     item.amount = +formatNum(Number(item.amount) * discount) / 100;
        // })
        let newDetailsList = detailsList.map((item) => {
            return {
                ...item,
                discountRate: discount,
                amount: +formatNum(Number(item.notAmount) * discount / 100),
            }
        })
        // console.log(detailsList)
        mode === "add" ? setDetailAddList(newDetailsList) : setDetailDataSource(newDetailsList)
    }
    const onTrunSaleSo = async () => {
        let { totalAll } = editDesc;
        totalAll = +repairFormatNum(totalAll);
        if (detailEditForm.status === DictCodeEnmu.SALE_ORDER_TRANSFER) {
            globalPrompt("message", { text: "该单据已转接不可再次转接" })
            return
        }
        let { customerCode, customerName, payType, settlementPartyCode, bentityCode } = detailEditForm as { customerCode: string, payType: IVRMSettleTypeEnum, customerName: string, settlementPartyCode: string, bentityCode: string }
        if (!(customerCode && customerName && payType && settlementPartyCode)) {
            message.warning("请补全客户名称或结算类型或结算方")
            return false
        }
        // let { accountName, availableAmount, isBill, accountCustomerName } = await getSettlementParty({ settlementPartyCode, customerName, customerCode, payType, settlementsettlementPartyParams: getTreeNodeOne(settlementPartyCode as string)[0], bentityCode });

        // if (payType !== IVRMSettleTypeEnum.SETTLE_CASH) {
        //     if (accountName && availableAmount >= totalAll) {//有账户，但是额度大于开单金额的
        //         turnSaleTips(`当前${accountName},授信额度为${availableAmount}是否确认？？`, true, detailEditForm.saleOrderCode)
        //     } else if (accountName && availableAmount < totalAll) { //有账户，但是额度低于开单金额的
        //         turnSaleTips(`当前${accountName},授信额度为${availableAmount}小于开单金额${totalAll}，无法开单，是否确认？？`, false)
        //     } else if (!accountName) { //查对应没有账户的
        //         turnSaleTips(`当前${customerName}，无对应账户，无法开单，是否确认？？`, false)
        //     }
        // } else {
        await saveTrunSaleSo(detailEditForm?.saleOrderCode as string)
        // }
    }
    const turnSaleTips = (info: string, isSave: boolean, saleOrderCode: string = "") => {
        globalPrompt("modal", {
            title: "销售订单转接销售单",
            type: "warning",
            text: info,
            okText: "确定",
            onOk: debounce(async () => { isSave && await saveTrunSaleSo(saleOrderCode as string) }, 500),
            cancelText: "取消",
            onCancel: () => { }
        })
    }
    const saveTrunSaleSo = async (saleOrderCode: string) => {
        let retData = await onTransfer(saleOrderCode as string)
        if (!!retData) {
            replaceNav(selectedNavId, "5-2")
            message.success("转接销售单成功")
        }
    }
    const rightChildren = <>
        {
            mode == "edit" &&
            <YhAuth resCode={ResourceAuthEnum.S_SO_ED_TRANS}>
                <Button
                    className="mr-5"
                    type="primary"
                    shape="round"
                    disabled={topButsControl}
                    onClick={debounce(() => { onTrunSaleSo() }, 900)}
                >转销售单</Button>
            </YhAuth>
        }
        {mode !== "look" &&
            <YhAuth resCode={ResourceAuthEnum.S_SO_ED_DISC}>
                <Button
                    className="mr-5"
                    type="primary"
                    shape="round"
                    onClick={onDiscount}
                >快捷折扣</Button>
            </YhAuth>
        }
        {mode !== "look" &&
            <YhAuth resCode={ResourceAuthEnum.S_SO_ED_SAVE}>
                <Button
                    className="mr-5"
                    type="primary"
                    shape="round"
                    loading={saveLoading}
                    onClick={debounce(() => { save() }, 900)}
                >{saveLoading ? '保存中' : '保存'}</Button>
            </YhAuth>}
        {mode !== "look" && <Button
            className="mr-5"
            type="primary"
            shape="round"
            onClick={onRefresh}
        >刷新</Button>}
        <Button
            className="mr-5"
            type="primary"
            shape="round"
            onClick={goBack}
        >返回</Button>
    </>

    //车辆类型
    const vehicleTypeChange = (value: string, option: ISelectOption) => {
        option && onChange({ vehicleTypeName: option.label, vehicleTypeCode: option.value });
    }
    //维修类型
    const maintenanceTypeChange = (value: string, option: ISelectOption) => {
        option && onChange({ maintenanceTypeName: option.label, maintenanceTypeCode: option.value });
    }
    //结算方
    const settlementPartyChange = (value: string, option: ISelectOption) => {
        option && onChange({ settlementPartyName: option.label, settlementPartyCode: option.value });
    }
    //结算方式
    const paymentMethodChange = (value: string, option: ISelectOption) => {
        option && onChange({ paymentMethodName: option.label, paymentMethodCode: option.value });
    }
    //客户类型
    const customerTypeChange = (value: string, option: ISelectOption) => {
        option && onChange({ customerTypeName: option.label, customerTypeCode: option.value });
    }
    //发票类型
    const invoiceTypeChange = (value: string, option: ISelectOption) => {
        option && onChange({ invoiceTypeName: option.label, invoiceTypeCode: option.value });
    }
    //销售实体
    const bentityChange = (value: string, option: ISelectOption) => {
        option && onChange({ bentityName: option.label, bentityCode: option.value });
    }
    //所属站点
    const shopNameChange = (value: string, option: ISelectOption) => {
        option && onChange({ shopId: option.value, shopCode: option.code, shopName: option.label });
    }
    //销售类型
    const salesTypeChange = (value: string, option: ISelectOption) => {
        option && onChange({ salesTypeName: option.label, salesTypeCode: option.value, priceTypeName: undefined, priceTypeCode: undefined });
        if (value === ISalesTypeEnum.NORMAL_SALES) {
            option && onChange({ salesTypeName: option.label, salesTypeCode: option.value, priceTypeName: "零售价", priceTypeCode: "price-selection.retail" });
        }
        if (!value) {
            onChange({ salesTypeName: undefined, salesTypeCode: undefined, priceTypeName: undefined, priceTypeCode: undefined });
        }
        if (value) {
            alterListPrice(value === ISalesTypeEnum.NORMAL_SALES ? "price-selection.retail" : undefined, value, customerCode as string);
        }
    }

    //售价选择
    const priceTypeChange = (value: string, option: ISelectOption) => {
        option && onChange({ priceTypeName: option.label, priceTypeCode: option.value });
        if (value) {
            alterListPrice(value, salesTypeCode, customerCode as string);
        }
    }
    //from销售类型，售价选择时更改 详情表格的价格信息
    const alterListPrice = async (priceTypeCode: string | undefined, salesTypeCode: string, customerCode: string) => {
        let detailsList = mode == "add" ? detailAddList : detailDataSource;
        if (!detailsList.length) return;
        if (!salesTypeCode || !customerCode) {
            message.warning("请补全客户名称，销售类型才可以，对下列表格的价格数据进行更改");
            return false;
        }
        let newDetailsList = await Promise.all(detailsList.map(async item => {
            let { price, num, discountRate, stockId, materialCode, ...params } = item as any;
            let newPrice: number = 0;
            if (salesTypeCode === ISalesTypeEnum.NORMAL_SALES) {
                switch (priceTypeCode) {
                    //售价选择 客户最近销价 (需要通过接口查询，客户最近一次的销售价)
                    case IPriceTypeEnum.CUSTOMER_LATEST:
                        let { retData: { price } } = await purchaseDetailsService.recentSalesPrice(shopId, materialCode, customerCode as string);
                        newPrice = +price;
                        break;
                    //售价选择 最近销价
                    case IPriceTypeEnum.RECENT:
                        newPrice = await findPoDetailPrice(stockId, ["lateSalePrice", "retailPrice"], true)
                        break;
                    //售价选择 零售价
                    case IPriceTypeEnum.RETAIL:
                        newPrice = await findPoDetailPrice(stockId, ["retailPrice"])
                        break;
                    //售价选择 采购成本价
                    case IPriceTypeEnum.PUR_COST:
                        newPrice = await findPoDetailPrice(stockId, ["latestPurPrice", "purchasePrice"], true)
                        break;
                    //售价选择 档案进价
                    case IPriceTypeEnum.BUYING_PRICE:
                        newPrice = await findPoDetailPrice(stockId, ["purchasePrice"])
                        break;
                }
            } else {
                newPrice = await findPoDetailPrice(stockId, ["latestPurPrice", "purchasePrice"], true)// latestPurPrice ?? purchasePrice
            }
            return {
                ...item,
                num,
                price: newPrice,
                notAmount: +formatNum(num * newPrice),
                amount: +formatNum((num * newPrice * discountRate) / 100)
            }
        }))
        // console.log(newDetailsList)
        mode === "add" ? setDetailAddList(newDetailsList) : setDetailDataSource(newDetailsList);
    }
    //根据销售类型，售价选择去查询采购明细对应的单价
    const findPoDetailPrice = async (stockId: string, priceType: string[], priceTypeLen?: boolean) => {
        let resultPrice: number = 0;
        await stockStatisticService.findId(stockId).then(async res => {
            let retData = await res.retData;
            resultPrice = priceTypeLen ? retData?.[priceType[0]] ?? retData?.[priceType[1]] : retData?.[priceType[0]];

        })
        return resultPrice
    }
    useEffect(() => {
        getVehicleAllList()
    }, [mode])

    const getVehicleAllList = async (param?: IVehicleFields) => {
        let params = {
            ...param,
            shopId,
            pageSize: 2000,
            pageNum: 1
        }
        const { retData } = await vehicleService.pages(params)
        const { records } = retData
        // if (records.length === 0) { globalPrompt("message", { text: "该客户下没有车辆，点击左侧车辆牌照去新增吧!", type: "warning" }) }
        let newRecords = records.map(item => {
            return {
                ...item,
                label: item.licensePlate,
                value: item.licensePlate
            }
        })
        mode === "add" ? setVehicleAddAll(newRecords) : setVehicleEditAll(newRecords)
    }
    //客户名称
    const customerChange = (value: string, option: ISelectOption) => {
        if (value && option) {
            let { name, code, contact, phone, address, categoryCode, categoryName } = getFindItem(value, CustomerData)
            option && onChange({
                customerName: option.label,
                customerCode: option.value,
                contact,
                phone,
                address,
                customerTypeCode: categoryCode,
                customerTypeName: categoryName,
                licensePlate: null,
                vehicleTypeCode: null,
                vehicleTypeName: null,
                vin: null
            });
        }
        getVehicleAllList({ customerCode: option?.value as string })

    }
    //车辆牌照
    const vehicleChange = (value: string, option: ISelectOption) => {
        let VehicleIList = mode === "add" ? vehicleAddAll : vehicleEditAll
        if (value && option) {
            let { customerName, customerCode, licensePlate, model, brandCode, brandName, categoryCode, categoryName, phone, contact, address, vin, typeCode, typeName } = getVehicleItem(value, VehicleIList)
            option && onChange({
                customerName,
                customerCode,
                contact,
                phone,
                address,
                vin,
                licensePlate,
                vehicleTypeCode: categoryCode,
                vehicleTypeName: categoryName,
                customerTypeCode: typeCode,
                customerTypeName: typeName,
                vehicleModel: model,
            });
        }
    }
    //vin码
    const vinChange = (value: string, option: ISelectOption) => {
        let VehicleIList: any = mode === "add" ? vehicleAddAll : vehicleEditAll
        if (value && option) {

            let { customerName, customerCode, licensePlate, brandCode, brandName, categoryCode, categoryName, phone, contact, address, vin, typeCode, typeName, model } = getVinItem(value, VehicleIList)
            option && onChange({
                customerName,
                customerCode,
                contact,
                phone,
                customerAddress: address,
                vin,
                licensePlate,
                vehicleTypeCode: categoryCode,
                vehicleTypeName: categoryName,
                vehicleModel: model,
                customerTypeCode: typeCode,
                customerTypeName: typeName,
            });
        }
    }
    const typeForm = {
        add: { ...detailAddForm },
        edit: detailEditForm,
        look: detailLookForm
    }
    const goCustomer = () => {
        replaceNav(
            selectedNavId,
            "13-5-1-1",
            {
                id: "", mode: "add", parentInfo: {
                    mode,
                    selectedNavId,
                    id
                }
            },
            true)
    }
    const goVehicle = () => {
        replaceNav(
            selectedNavId,
            "13-5-2-1",
            {
                id: "", mode: "add", parentInfo: {
                    mode,
                    selectedNavId,
                    id,
                    customerCode: typeForm[mode].customerCode
                }
            },
            true)
    }

    const onConsumption = () => {
        let { customerCode, customerName } = typeForm[mode]
        if (!customerCode) {
            return message.warning("请先选择客户")
        }
        setConsumeHistoryVisible(true)
        setConsumeHistoryModel({ customerName: customerName as string })
    }
    // const onRepairHistory = () => {
    //     if (!typeForm[mode].customerCode) {
    //         return message.warning("请先选择客户")
    //     }
    //     setRepairHistoryModel(true)
    // }

    const title = <>
        <span>基础信息</span>
        <Tooltip placement="topLeft" title="消费记录">
            <FontIcon type="icon-xiaofeijilu" style={{ marginLeft: "10px", cursor: "pointer", color: "#6C72F3" }} onClick={onConsumption}
            />
        </Tooltip>
        <a className="color-blue" style={{ float: 'right', fontSize: '17px' }} onClick={() => setMore(!more)}>{more ? '更多>>' : "隐藏"}</a>
    </>
    const normFile = (e: UploadChangeParam) => {
        // let filetypes: string[] = ['.jpg', '.png', '.jpeg', 'svg', '.gif', '.pdf', '.doc']
        // let isType: boolean = false
        // let fileEnd: string = e?.file.name.substring(e?.file.name.lastIndexOf('.'))
        // isType = filetypes?.includes(fileEnd) ?? false
        if (e?.file.status === 'done') {
            if (e?.file?.response?.retCode == 0) {
                const data = {
                    name: e.file.name,
                    size: e.file.size,
                    type: e.file.type,
                    uid: e?.file?.response?.retData,
                }
                e.fileList = [data]
                // e.fileList[e.fileList.length - 1] = data
            } else {
                message.error('文件上传失败，请重新上传!')
                e.fileList?.pop()
            }
        }
        if (e.file.status === 'error') {
            message.error('文件上传失败，请重新上传!')
            e.fileList?.pop()
        }
        if (Array.isArray(e)) {
            return e
        }
        // if (!isType) {
        //     e.fileList?.pop()
        // }
        return e && e.fileList
    }

    const onPreview = (file: UploadFile<any>) => {
        const { uid, name } = file
        const type = uid.split('.')[1]
        if (['jpg', 'png', 'jpeg', 'gif'].includes(type)) {
            Modal.info({
                title: '图片查看(点击图片放大)',
                content: <Image style={{ width: '100%' }} src={getBaseImgLookUrl(uid)} />,
                okText: '确定',
                cancelText: '取消',
                centered: true,
                width: 800,
            })
        } else {
            // window.open(getBaseImgLookUrl(uid))
            fileDownload(getBaseImgLookUrl(uid), name)
        }
    }
    const [payTypeList, setPayTypeList] = useState<ISelectOption[]>([])
    useEffect(() => {
        // if( shopCode=='SHOP-M-00000016'||shopCode=='SHOP-M-00000017'||shopCode=='SHOP-M-00000018'){
        setPayTypeList(getSelectedDictOne(DictCodeEnmu.SETTLE_TYPE))
        // }else{
        //     setPayTypeList(getSelectedDictOne(DictCodeEnmu.SETTLE_TYPE).map((item)=>{
        //         return{...item,disabled:item.value=='settle-type.credit'?true:false}}))        }
    }, [])
    const baseFormItem: IYhFormItemsBox = {
        title: title,
        // rightChildren,
        items: [
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: <span className="click-span" onClick={goCustomer}>客户名称</span>,
                fieldName: "customerCode",
                options: transOptions(CustomerData),
                onSelectChange: customerChange,
                allowClear: true,
                showSearch: true,
                rules: [{ required: true, message: "请选择客户名称" }]
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "联系人",
                fieldName: "contact",
                rules: [{ required: true, message: "请输入联系人" }]
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "联系电话",
                fieldName: "phone",
                rules: [{ required: true, message: "请输入联系电话" }]
            }, {
                type: FormItemTypeEnum.Select,
                allowClear: true,
                showSearch: true,
                fieldLabel: "销售类型",
                fieldName: "salesTypeCode",
                options: getSelectedDictOne(DictCodeEnmu.SALES_TYPE),
                onSelectChange: salesTypeChange,
                // disable: mode !== "add" ? true : false,
                rules: [{ required: true, message: "请选择销售类型" }]
            }, {
                type: FormItemTypeEnum.Select,
                fieldLabel: "销售实体",
                fieldName: "bentityCode",
                options: beShopDs,
                allowClear: true,
                showSearch: true,
                onSelectChange: bentityChange,
                rules: [{ required: true, message: "请选择销售实体" }]
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: "所属站点",
                fieldName: "shopId",
                options: allShopDs,
                showSearch: false,
                onSelectChange: shopNameChange,
                rules: [{ required: true, message: "请选择所属站点" }],
                disable: shopType === 0 && mode == 'add' ? false : true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "shopName",
                fieldName: "shopName",
                hidden: true
            },
            //  {
            //     type: FormItemTypeEnum.Select,
            //     allowClear: true,
            //     showSearch: true,
            //     fieldLabel: "售价选择",
            //     fieldName: "priceTypeCode",
            //     options: getSelectedDictOne(DictCodeEnmu.PRICE_SELECTION),
            //     disable: true,
            //     onSelectChange: priceTypeChange,
            //     disable: salesTypeCode !== ISalesTypeEnum.NORMAL_SALES, // mode !== "add" ? true : addSaleType !== ISalesTypeEnum.NORMAL_SALES,
            // },
            {
                type: FormItemTypeEnum.Select,
                allowClear: true,
                showSearch: true,
                fieldLabel: "结算方",
                fieldName: "settlementPartyCode",
                options: getSelectedDictOne(DictCodeEnmu.SETTLE_PARTY),
                onSelectChange: settlementPartyChange,
                rules: [{ required: true, message: "请选择结算方" }]
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "结算方",
                fieldName: "settlementPartyName",
                hidden: mode !== "look"
            }, {
                type: FormItemTypeEnum.Select,
                allowClear: true,
                showSearch: true,
                fieldLabel: "结算类型",
                fieldName: "payType",
                options: payTypeList,
                rules: [{ required: true, message: "请选择结算类型" }],
            }, {
                type: FormItemTypeEnum.Select,
                allowClear: true,
                showSearch: true,
                fieldLabel: "客户类型",
                fieldName: "customerTypeCode",
                options: getSelectedDictOne(DictCodeEnmu.CUSTOMER_TYPE),
                onSelectChange: customerTypeChange,
                disable: true,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "客户地址",
                fieldName: "address",
                // span: 5,
                // labelCol: { offset: 1 },
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "备注",
                fieldName: "note",
                span: 8,
                labelCol: { span: 24 },

            },

            // {
            //     type: FormItemTypeEnum.Button,
            //     fieldLabel: <a className="color-blue text-line" onClick={() => setMore(!more)}>{more ? '更多>>' : "隐藏"}</a>,
            //     fieldName: "none",
            //     span: 1,
            //     labelCol: { offset: 5 },
            //      }, 
            // {
            //     type: FormItemTypeEnum.Input,
            //     fieldLabel: "整单优惠",
            //     fieldName: "favorableAmount",
            //     rules: [{ type: 'number', transform: (value) => Math.abs(Number(value)), message: `当前不是一个有效数字`, }],
            //     hidden: more,
            // },
            // {
            //     type: FormItemTypeEnum.Select,
            //     allowClear: true,
            //     showSearch: true,
            //     fieldLabel: "发票类型",
            //     fieldName: "invoiceTypeCode",
            //     options: getSelectedDictOne(DictCodeEnmu.INVOICE_TYPE),
            //     onSelectChange: invoiceTypeChange,
            //     hidden: more,
            // }, {
            //     type: FormItemTypeEnum.Select,
            //     allowClear: true,
            //     showSearch: true,
            //     fieldLabel: "车辆类型",
            //     fieldName: "vehicleTypeCode",
            //     options: getSelectedDictOne(DictCodeEnmu.VEHICLE_TYPE),
            //     onSelectChange: vehicleTypeChange,
            //     hidden: more,
            // }, {
            //     type: FormItemTypeEnum.Select,
            //     fieldLabel: <span className="click-span" onClick={goVehicle}>车辆牌照</span>,
            //     fieldName: "licensePlate",
            //     allowClear: true,
            //     showSearch: true,
            //     options: mode === "add" ? vehicleOption(vehicleAddAll) : vehicleOption(vehicleEditAll),
            //     onSelectChange: vehicleChange,
            //     hidden: more,
            // }, {
            //     type: FormItemTypeEnum.Select,
            //     fieldLabel: "VIN码",
            //     fieldName: "vin",
            //     allowClear: true,
            //     showSearch: true,
            //     onSelectChange: vinChange,
            //     options: mode === "add" ? vinOption(vehicleAddAll) : vinOption(vehicleEditAll),
            //     hidden: more,
            // }, {
            //     type: FormItemTypeEnum.Input,
            //     fieldLabel: "工作小时",
            //     fieldName: "workingHours",
            //     hidden: more,

            //     // rules: [{ required: true, message: "请选择发票类型" }]
            // },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "制单员",
                fieldName: "createUser",
                disable: true,
                hidden: more,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "制单时间",
                fieldName: "createTime",
                disable: true,
                hidden: more,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "转接人",
                fieldName: "updateUser",
                disable: true,
                hidden: more,
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "转接时间",
                fieldName: "updateTime",
                disable: true,
                hidden: more,
            },
            // {
            //     type: FormItemTypeEnum.Other,
            //     fieldLabel: '附件',
            //     fieldName: 'file',
            //     colClassName: 'ant-col-h-auto',
            //     span: 12,
            //     formItem: (
            //         <Form.Item name="fileList" label="附件" valuePropName="fileList" getValueFromEvent={normFile} labelCol={{ span: 3 }}>
            //             <Upload
            //                 onPreview={onPreview}
            //                 name="file"
            //                 action={getBaseImgUploadUrl()}
            //                 data={getBaseUploadData()}
            //                 listType="picture"
            //                 beforeUpload={(file:any) => {
            //                     // let fileEnd: string = file.name.substring(file.name.lastIndexOf('.'))
            //                     // // let filetypes: string[] = [".jpg", ".png", ".doc", ".xls", ".pdf", ".docx", ".xlsx", ".mp4", ".mp3"];
            //                     // let filetypes: string[] = ['.jpg', '.png', '.jpeg', 'svg', '.gif', '.pdf', '.doc']
            //                     // // var filetypes = [".jpg", ".png", ".rar", ".txt", ".zip", ".doc", ".ppt", ".xls", ".pdf", ".docx", ".xlsx", ".mp4", ".mp3"];
            //                     // let isType = filetypes?.includes(fileEnd)
            //                     // if (!isType) {
            //                     //     message.error('不支持该格式的上传,当前仅支持 图片、pdf和.doc 类型文件')
            //                     // }
            //                     const isLt20M = file.size / 1024 / 1024 < 20
            //                     if (!isLt20M) {
            //                         message.error('上传到文件不能超过20M')
            // file.status='done'
            //                     }
            //                     // return isType && isLt20M
            //                     return isLt20M
            //                 }}
            //                 iconRender={(file) => {
            //                     return (
            //                         <FontIcon
            //                             onClick={() => {
            //                                 onPreview(file)
            //                             }}
            //                             style={{ fontSize: '24px' }}
            //                             type="icon-tupian"
            //                         />
            //                     )

            //                 }}
            //             >
            //         {mode !== 'look' &&
            //             <>
            //                 <Button icon={<UploadOutlined />} >选择文件上传</Button>
            //                 </>}
            //             </Upload>
            //         </Form.Item>
            //     ),
            // },
            //带出字段
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "销售实体名称",
                fieldName: "bentityName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "客户名称",
                fieldName: "customerName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "车辆类型Name",
                fieldName: "vehicleTypeName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "维修类型Name",
                fieldName: "maintenanceTypeName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "结算方Name",
                fieldName: "settlementPartyName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "结算方式Name",
                fieldName: "paymentMethodName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "客户类型Name",
                fieldName: "customerTypeName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "发票类型Name",
                fieldName: "invoiceTypeName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "车辆里程",
                fieldName: "mileage",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "车辆型号",
                fieldName: "vehicleModel",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "售价选择Name",
                fieldName: "priceTypeName",
                hidden: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "销售类型",
                fieldName: "salesTypeName",
                hidden: true
            }
        ]
    };



    const onChange = (changedValues: { [key: string]: any }) => {
        mode === "add" ? updateAddFormVal(changedValues) : updatEditFormVal(changedValues)
        setTopButsControl(true)
    }
    const poFromConfig: IYhFormBox = {
        formRef: IFormRef,
        labelCol: { span: 6 },
        disabled: mode === DetailType.look,
        labelAlign: "right",
        formValues: { ...typeForm[mode] },
        onChange,
        boxs: [baseFormItem]
    }


    return (
        <>
            <YHDetailNav
                title={
                    <span>
                        销售订单号:
                        <span style={{ margin: '0 30px 0 10px', fontWeight: 600, color: '#3e67f4' }}>{typeForm[mode].saleOrderCode ?? "暂无"}</span>
                        状态:
                        <span style={{ margin: '0 30px 0 10px', fontWeight: 600, color: '#3e67f4' }}>{(typeForm[mode]?.status && getTreeNodeName(typeForm[mode]?.status as string)) ?? "暂无"}</span>
                    </span>
                }
                btns={rightChildren}
                style={{ marginBottom: '6px' }}
            />
            <YhFormBox {...poFromConfig} />
        </>
    )
}
